import { Button, Dialog, Icons, Intent, Size } from "construct-ui";
import ConfirmationDialogView from "../../../components/common/confirmation-box.view";
import SingleSelectCommonComponentView from "../../../components/common/single-select-common-component.view";
import { messageComponent } from "../../../components/message/message.component";
import paginationComponent from "../../../components/pagination/pagination.component";
import CodeByCategorySelectionComponent from "../../../components/codemaster/codemaster-category-search-select.component"
import masterConfigurationModel from "../../../models/config-master.model";
import loginModel from "../../../models/login.model";
import ViewBase from "../../view-base.view";
import MasterConfigUploadView from "./master-config-upload.view";
import MasterConfigurationDropdownView from "./master-configuration-dropdown.view";

export default function MasterDetailsEditView() {
  ViewBase.call(this);
  let isLoading = false;
  let _gridClass = "";
  let onChange = () => { };
  let _isEdit = false;
  let isMsgOpen = false;
  let showMsg = "";
  let msgTitle = "";
  let _isEditableAll = false;
  let isUploadOpen = false;
  let isDeleteOpen = false;
  let masterConfig = [];
  let masterConfigList = [];

  let inputDatModel = {
    pageIndex: 1, pageSize: 10, totalSize: 0, condition1: { code: "", name: "" }, condition2: { code: "", name: "" }, subsidiaryCode: "", recordType: "",
    condition1Value: "", condition2Value: "", data: [], keys: [], location: ""
  };

  let _goBack = () => {
    onChange();
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    inputDatModel.pageIndex = pageIndex;
    inputDatModel.pageSize = pageSize;
    _loadDataForUpdate();
  }

  let onPageChanged = (pageIndex) => {
    inputDatModel.pageIndex = pageIndex;
    _loadDataForUpdate();
  }

  let _geterateModel = () => {
    _loadDataForUpdate();
  }

  let _clearFilter = () => {
    inputDatModel.condition1 = { name: "", code: "" };
    inputDatModel.condition2 = { name: "", code: "" };
    inputDatModel.condition1Value = "";
    inputDatModel.condition2Value = "";
  }

  let _search = () => {
    _loadDataForUpdate();
  }

  let _loadDataForUpdate = () => {
    isLoading = true;
    masterConfig = [];
    masterConfigList = [];
    inputDatModel.data = [];
    masterConfigurationModel.getConfigMasterDataList(
      (result) => {
        isLoading = false;
        _isEditableAll = result.editableYN == "Y" ? true : false;
        _gridClass = _isEditableAll ? ".col-md-8.col-xl-9" : ".col-md-12";

        inputDatModel.totalCount = result.pagination.total;
        inputDatModel.pageIndex = result.pagination.pageIndex;
        inputDatModel.pageSize = result.pagination.pageSize;
        result.columns.forEach(element => {
          if (element.columnName != "CREATE_BY" && element.columnName != "CREATE_DATE" && element.columnName != "UPDATE_BY" && element.columnName != "UPDATE_DATE" && element.dataType != "") {
            let cmItem = result.popupData.filter(x => x.label == element.columnName);
            if (cmItem.length == 1) {
              if (cmItem[0].popupCode == "") {
                masterConfig.push({ code: element.columnName, value: "", codemasterCode: cmItem[0].popupCode, codemasterType: cmItem[0].popupValue });
              }
              else {
                masterConfig.push({ code: element.columnName, value: { code: "", name: "" }, codemasterCode: cmItem[0].popupCode, codemasterType: cmItem[0].popupValue });
              }
            } else {
              masterConfig.push({ code: element.columnName, value: { code: "", name: "" }, codemasterCode: "", codemasterType: "" });
            }
          }
          masterConfigList.push({ code: element.columnName, name: element.columnName });
        });
        result.data.forEach(element => {
          let data = [];
          if (element == null) {
            result.columns.forEach(col => {
              data.push("");
            });
          }
          else {
            let arr = element.split('^^');
            arr.forEach((val, index) => {
              data.push({ column: masterConfigList[index].name, data: val });
            });
          }
          inputDatModel.data.push(data);
        });
      },
      (error) => {
        isLoading = false;
        this.handleError(error);
      },
      inputDatModel
    )
  }

  let _loadData = (data) => {
    masterConfig.forEach(element => {
      if (data != null) {
        if (element.codemasterCode == "") {
          let rowVal = data.filter(x => x.column == element.code)
          element.value = rowVal.length == 1 ? rowVal[0].data : "";
        }
        else {
          let rowVal = data.filter(x => x.column == element.code)
          element.value = rowVal.length == 1 ? { code: rowVal[0].data, name: rowVal[0].data } : { code: "", name: "" };
        }
      }
      else {
        element.value = "";
      }
    });
  }

  let _clearForm = () => {
    _isEdit = false;
    masterConfig.forEach(element => {
      element.value = "";
    });
  }

  let _addDeleteConfig = (type) => {
    const promises = [];
    const locations = inputDatModel.location ? inputDatModel.location.split(',') : [""];
    let countryCode = inputDatModel.subsidiaryCode == "" ? "" : loginModel.credentials.country;
    let values = _getValues(type);
    isLoading = true;
    if (locations.length > 0) {
      for (let i = 0; i < locations.length; i++) {
        promises.push(new Promise((resolve, reject) => {
          masterConfigurationModel.addDeleteMasterConfiguration(
            (result) => {
              resolve(result);
            },
            (error) => {
              reject(error);
            },
            countryCode, inputDatModel.recordType, values, locations[i]
          )
        }));
      }
    }

    Promise.all(promises)
      .then((result) => {
        isLoading = false;
        isMsgOpen = true;
        showMsg = result[0][0].message;
        msgTitle = result[0][0].transStatus;
        _clearForm();
        _loadDataForUpdate();
      }).catch(error => {
        // console.error('Error:', error)
        isLoading = false;
        this.handleError(error);
      });

  }

  let _getValues = (type) => {
    let formattedObjArr = [];
    masterConfig.forEach(element => {
      if (element.codemasterCode == "") {
        formattedObjArr.push(element.value);
      }
      else {
        formattedObjArr.push(element.value.code);
      }
    });
    return type + "^" + formattedObjArr.join('^');
  }

  let _onAdd = () => {
    _addDeleteConfig('C');
  }

  let _onDelete = () => {
    isDeleteOpen = false;
    _addDeleteConfig('D');
  }

  let _dialogClosed = () => {
    isMsgOpen = false;
  }

  let _downloadTemplate = () => {
    isLoading = true;
    masterConfigurationModel.downloadTemplate(
      (result) => {
        isLoading = false;
      },
      (error) => {
        isLoading = false;
        this.handleError(error);
      },
      inputDatModel.recordType, inputDatModel.subsidiaryCode
    )
  }

  return {
    oninit: function (vnode) {
      if (vnode.attrs.onChange) {
        onChange = vnode.attrs.onChange;
      }
      if (vnode.attrs.data) {
        inputDatModel.subsidiaryCode = vnode.attrs.data.subsidiaryCode;
        inputDatModel.recordType = vnode.attrs.data.recordType;
        inputDatModel.keys = vnode.attrs.data.keys;
        inputDatModel.location = vnode.attrs.data.location;
      }
      _geterateModel(vnode);
    },
    view: (vnode) => {
      return [
        m('.row',
          m(".col-12",
            m('.d-flex.mb-3',
              m('h1.mb-2', m('i.bi.bi-arrow-left.cursor-pointer', {
                onclick: () => {
                  _goBack();
                }
              })),
              m('.flex-grow-1',
                m('h1.mb-2', vnode.attrs.data.recordType)
              ),
              _isEditableAll && m('.d-grid .gap-2 .d-sm-flex .justify-content-sm-center',
                m('.input-group.w-auto',
                  m('button.btn.btn-primary.dropdown-toggle.dropdown-toggle-split[type=button][data-bs-toggle=dropdown][arie-expanded=false]',
                    m('i.bi.bi-file-earmark-arrow-down-fill'),
                    this.getText("LT00000500", "Download/Upload")
                  ),
                  m('ul.dropdown-menu',
                    m('li',
                      m('a.dropdown-item[href="javascript:void(0);"]', {
                        onclick: _downloadTemplate
                      },
                        this.getText("LT00000218", "Download Template")
                      )
                    ),
                    m('li',
                      m('a.dropdown-item[href="javascript:void(0);"]', {
                        onclick: () => { isUploadOpen = true; }
                      },
                        this.getText("LT00000572", "Upload Data")
                      )
                    ),
                  ),
                ),
              )
            ),
            m('.card.mb-3',
              m('.card-body',
                m('.row.g-4',
                  m('.col-md-3',
                    m('.col',
                      m('label.form-label', this.getText("LT00000573", "Condition 1")),
                      m(SingleSelectCommonComponentView, {
                        disabled: false, iconList: [], items: masterConfigList, selectedItem: inputDatModel.condition1, handleSelect: (sItem) => {
                          inputDatModel.condition1 = sItem;
                        }
                      }),
                    ),
                  ),
                  m('.col-md-3',
                    m('.col.mt-1_9',
                      m('input[type=text][value="' + inputDatModel.condition1Value + '"].form-control.form-control-bg', { onchange: (e) => { inputDatModel.condition1Value = e.target.value } })
                    ),
                  ),
                  m('.col-md-3',
                    m('.col',
                      m('label.form-label', this.getText("LT00000574", "Condition 2")),
                      m(SingleSelectCommonComponentView, {
                        disabled: false, iconList: [], items: masterConfigList, selectedItem: inputDatModel.condition2, handleSelect: (sItem) => {
                          inputDatModel.condition2 = sItem;
                        }
                      }),
                    ),
                  ),
                  m('.col-md-3',
                    m('.col.mt-1_9',
                      m('input[type=text][value="' + inputDatModel.condition2Value + '"].form-control.form-control-bg', { onchange: (e) => { inputDatModel.condition2Value = e.target.value } })
                    ),
                  ),
                  m('.col-md-3.gap-2.d-flex.align-items-end.justify-content-end.justify-content-md-start',
                    m('button.btn.btn-primary', { onclick: () => { _search() } }, this.getText("LT00000001", "Search")),
                    m('button.btn.btn-white', {
                      onclick: () => {
                        _clearFilter();
                      }
                    }, this.getText("LT00000031", "Clear")),
                  ),
                )
              )
            ),
            m(".row.g-3",
              // Section: Add question
              _isEditableAll && m('.col-md-4.col-xl-3',
                m(".card",
                  m('.card-body.question-form-container',
                    m('.row.g-3',
                      masterConfig.map(gc => [
                        m('.col-12',
                          inputDatModel.keys.indexOf(gc.code) > -1 ? m('label.form-label', gc.code + " [" + this.getText("LT00000575", "KEY") + "]") : m('label.form-label', gc.code),
                          gc.codemasterType == "" &&
                          m("input[type=text].form-control", {
                            value: gc.value,
                            disabled: _isEdit && inputDatModel.keys.indexOf(gc.code) > -1,
                            onchange: (e) => {
                              gc.value = e.target.value;
                            }
                          }),
                          gc.codemasterType == "LIST" &&
                          m(MasterConfigurationDropdownView, {
                            handleSelect: (item) => {
                              gc.value = { code: item.code, name: item.name };
                            },
                            selectedItem: gc.value,
                            disabled: _isEdit && inputDatModel.keys.indexOf(gc.code) > -1,
                            code: gc.codemasterCode
                          }),
                          gc.codemasterType == "SEARCH" &&
                          m(CodeByCategorySelectionComponent, {
                            id: gc.code,
                            title: gc.code,
                            category: gc.codemasterCode,
                            multiple: false,
                            selectedItems: gc.value && gc.value.code ? [gc.value] : [],
                            onSelect: (selectedItems) => {
                              gc.value = selectedItems;
                            }
                          })
                        ),
                      ]),
                    ),
                  ),
                  m('.card-body', { style: 'border-top: 1px solid var(--blue-color-light);' },
                    m('.d-flex.gap-2.justify-content-end.my-2',
                      m(Button, {
                        iconLeft: _isEdit ? Icons.EDIT_2 : Icons.PLUS,
                        intent: Intent.PRIMARY,
                        label: _isEdit ? this.getText("LT00000498", "Update") : this.getText("LT00000090", "Add"),
                        rounded: true,
                        size: Size.XS,
                        onclick: () => {
                          _onAdd();
                        }
                      }),
                      m(Button, {
                        intent: Intent.PRIMARY,
                        label: this.getText("LT00000031", "Clear"),
                        outlined: true,
                        rounded: true,
                        size: Size.XS,
                        onclick: () => {
                          _clearForm();
                        }
                      }),
                    ),
                  )
                )
              ),
              // Section: Question list
              m(_gridClass,
                m(".card",
                  m('.card-body.question-list-container',
                    m('.row',
                      m(".col-12.p-0",
                        m(".table-responsive",
                          m("table.table", [
                            m("thead.thead-bggrey",
                              m("tr.align-middle", [
                                _isEditableAll && m("th.center", { "scope": "col" }, this.getText("LT00000092", "Action")),
                                masterConfigList.map(key =>
                                  [
                                    m("th.center", { "scope": "col" }, key.code)
                                  ]),
                              ])
                            ),
                            m("tbody",
                              (inputDatModel.data.length == 0 && inputDatModel.data.length == 0) &&
                              m("tr", { "class": "align-middle" },
                                m("td", { "colspan": "9" }, this.getText("EM00000141", "No records found."))
                              ),
                              inputDatModel.data.map(row => [
                                m("tr",
                                  _isEditableAll &&
                                  m("td.center",
                                    m('i.bi.bi-pencil-square.list-action-icon[title="Edit"]', {
                                      onclick: () => {
                                        _isEdit = true;
                                        _loadData(row);
                                      }
                                    }),
                                    m('i.bi.bi-trash.list-action-icon[title="Info"]', {
                                      onclick: () => {
                                        _loadData(row);
                                        isDeleteOpen = true;
                                      }
                                    })
                                  ),
                                  row.map(column => [
                                    m("td", column.data),
                                  ]),
                                )
                              ]),
                            )
                          ])
                        ),
                        !isLoading &&
                        m(".px-3",
                          m(paginationComponent, { currentPage: inputDatModel.pageIndex, pageSize: inputDatModel.pageSize, totalItems: inputDatModel.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                        )
                      )
                    ),
                  )
                ),
              ),
            )
          ),
          m(Dialog, {
            isOpen: isUploadOpen,
            transitionDuration: 200,
            closeOnOutsideClick: false,
            onClose: () => { isUploadOpen = false },
            title: this.getText("LT00000515", "Upload Excel"),
            content: m(MasterConfigUploadView, {
              recordType: vnode.attrs.data.recordType, recordCount: masterConfig.length + 1, onAddClose: () => { isUploadOpen = false }, onUploadCompleted: () => {
                isMsgOpen = true;
                isUploadOpen = false;
                showMsg = this.getText("EM00000358", "Please check the downloaded excel for the status");
                msgTitle = this.getText("EM00000359", "Upload has been completed");
                _loadDataForUpdate();

              }, location: inputDatModel.location
            }),
            "class": "cui-dialog-xxl"
          }),
          m(Dialog, {
            isOpen: isDeleteOpen,
            transitionDuration: 200,
            closeOnOutsideClick: false,
            onClose: () => { isDeleteOpen = false; },
            title: this.getText("LT00000043", "Confirm"),
            content: m(ConfirmationDialogView, { text: this.getText("EM00000265", "Are you sure you want to delete?") }),
            "class": "cui-dialog",
            footer: [
              m(Button, {
                label: this.getText("LT00000024", "No"),
                onclick: () => { isDeleteOpen = false; _clearForm(); }
              }),
              m(Button, {
                label: this.getText("LT00000023", "Yes"),
                intent: 'primary',
                onclick: _onDelete
              })
            ]
          }),
          m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
        ),
        this.getBaseViews()
      ];
    }
  }
}
